<div class="content-height d-lg-block d-none">
    <div class="row h-100">
        <div class="col-6 image-section position-relative">
            <div *ngIf="step === 'firstStep'" class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid " src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718101700711Working%203d%201%20%281%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-warning-faint mb-3">
                        <div class="col-1 faq-warning-div-height mt-n0">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718086250706Notification%201%20%281%29.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <p class="fw-bold fs-8">Please mention the university which you are most likely to take admission in.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center mx-2 bg-light border-warning-faint">
                        <div class="col-1 faq-warning-div-height mt-n0">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718086250706Notification%201%20%281%29.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <p class="fw-bold fs-8">If going for STEM Management programs Like STEM MBA, please select management option only.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="step === 'secondStep'" class="mt-2">
                <div class="d-flex justify-content-between flex-column  align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid mb-6" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718105034135Frame%201000002351%20%281%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n3">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718104747633Marks%201.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <h6>How will Academic Score help me get a education loan?</h6>
                                <p class="fs-8">Better academic scores increases your loan approval chances and reduces the rate of interest.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="step === 'thirdStep'" class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718104877523Working%203d%201%20%282%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n2">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718104747633Marks%201.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <h6>How will Aptitude test score help me get a education loan?</h6>
                                <p class="fs-8">Having better tests scores increases your loan approval chances and get approvals on priority.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <div class="container h-100">
                <div>
                    <apnst-common-header [configHeader]="configAcademicDetailsHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
                </div>

                <div class="">
                    <aerp-base-schema-form *ngIf="model && layout" [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
                    </aerp-base-schema-form>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="d-lg-none d-block">
    <div class="mt-5">
        <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
    </div>
    <div class="container">
        <div class="">
            <apnst-common-header [configHeader]="configAcademicDetailsHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
        </div>
        <div class="px-3 px-lg-6 mt-4">
            <aerp-base-schema-form *ngIf="model && layout" [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
            </aerp-base-schema-form>
        </div>
    </div>
</div>